import { Http } from '@/lib/http';

export class AssetOwnerService extends Http {
  constructor() {
    super();
    this.endPoint = '/loan-pro/app/loan-services/manage-loans/asset-owners'
  }

  async findAssetOwnerByTaxNumber(trn) {
    return this.httpClient().post(`${this.endPoint}/findAssetOwnerByTaxNumber/${trn}`)
  }

  getAssetOwners(page, limit, order='asc', sort='trn', search, excludedIds) {
    let queryString = [];
    if(page) {
      queryString.push(`page=${page}`)
    }
    if(limit) {
      queryString.push(`limit=${limit}`)
    }
    if(search) {
      queryString.push(`searchParam=${search}`);
    }
    if(excludedIds) {
      queryString.push(`excludedIds=${excludedIds.toString()}`);
    }
    queryString.push(`order=${order}`)
    queryString.push(`sort=${sort}`);
    return this.httpClient().get(`${this.endPoint}?${queryString.join('&')}`);
  }

  createAssetOwner(ownerDetails) {
    return this.httpClient().post(`${this.endPoint}`, ownerDetails);
  }

  updateAssetOwner(id, updates) {
    return this.httpClient().patch(`${this.endPoint}/${id}`, updates)
  }

  deleteAssetOwner(id) {
    return this.httpClient().delete(`${this.endPoint}/${id}`)
  }

  addOwnerToInsurance(ownerId, insuranceId, owner) {
    return this.httpClient().patch(`${this.endPoint}/insurance/${ownerId}/${insuranceId}`, owner)
  }

  removeOwnerFromInsurance(ownerId, insuranceId) {
    return this.httpClient().delete(`${this.endPoint}/insurance/${ownerId}/${insuranceId}`)
  }

  addOwnerToCollateral(ownerId, collateralId, owner) {
    return this.httpClient().patch(`${this.endPoint}/collateral/${ownerId}/${collateralId}`, owner)
  }

  removeOwnerFromCollateral(ownerId, collateralId) {
    return this.httpClient().delete(`${this.endPoint}/collateral/${ownerId}/${collateralId}`)
  }
}
